import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";

export interface ISDUIResponsiveValue<T> {
  mobile_and_above: T | undefined;
  tablet_and_above: T | undefined;
  desktop_and_above: T | undefined;
}

export const getResponsiveValueAtIndex = <T>(
  responsiveValues: ResponsiveValues<T[]>,
  index: number,
  defaultValue: T
): ResponsiveValues<T> => {
  return {
    mobileAndAbove: responsiveValues.mobileAndAbove[index] ?? defaultValue,
    tabletAndAbove: responsiveValues.tabletAndAbove?.[index],
    desktopAndAbove: responsiveValues.desktopAndAbove?.[index],
  };
};

export const convertServerResponsivePropertyToClientResponsiveProperty = <
  T,
  U extends ISDUIResponsiveValue<T>,
  V
>(
  defaultValue: T,
  convertServerToClientValue: (value: T) => V,
  serverResponsiveValues?: U
): ResponsiveValues<V> => {
  const values: ResponsiveValues<V> = {
    mobileAndAbove: convertServerToClientValue(
      serverResponsiveValues?.mobile_and_above ?? defaultValue
    ),
  };
  const tabletAndAbove = serverResponsiveValues?.tablet_and_above
    ? convertServerToClientValue(serverResponsiveValues?.tablet_and_above)
    : undefined;
  const desktopAndAbove = serverResponsiveValues?.desktop_and_above
    ? convertServerToClientValue(serverResponsiveValues?.desktop_and_above)
    : undefined;
  if (tabletAndAbove) {
    Object.assign(values, { tabletAndAbove });
  }
  if (desktopAndAbove) {
    Object.assign(values, { desktopAndAbove });
  }
  return values;
};

export const getResponsiveStylingClassNames = <T>(
  responsiveValues: ResponsiveValues<T>,
  responsiveClassNamesMap: Partial<Record<keyof ResponsiveValues<T>, string>>
) => {
  return Object.entries(responsiveValues)
    .filter(([_, value]) => value !== undefined)
    .map(([key]) => responsiveClassNamesMap[key as keyof ResponsiveValues<T>])
    .filter(isNotUndefined);
};
